module.exports = __webpack_public_path__ + "img/checked-circle.51811acf.svg";